
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suspend",
      function () {
        return require("private-next-pages/suspend.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suspend"])
      });
    }
  